import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable({
  providedIn: 'root'
})
export class CreateRequestService {
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),

  };
  constructor(private http: HttpClient, private UTS: UtilitiesService) { }

  getRetrieveCustomer(accountNumber, token) {
    const payload = { "accountNumber": accountNumber, "token": token };
    return this.http.post(
      `${environment.BASE_URL}/retrieveCustomer`,
      payload,
      this.httpOptions
    );
  }

  
  createRequest(data, token) {
    const payload = { "data": data, "token": token };
    return this.http.post(
      `${environment.BASE_URL}/createRequest`,
      payload,
      this.httpOptions
    );
  }
}
